module.exports = __webpack_public_path__ + "static/media/mail.5035404e.png";